import React, { useCallback } from 'react';
import IndividualChats from './blocks/IndividualChats';
import GroupChats from './blocks/GroupChats';
import { getCommonRoutePath } from '../../../helpers/Helpers';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { sessionStorageWrapper } from '../../../helpers/storageFactory';
import { CHANGE_CHATS_TAB, CHAT_INFO, RESET_ACTIVE_CHAT } from '../../../redux/actions/currentChatActions';
import Loader from '../../../components/Loader';
import { CLEAR_MESSAGES_STORE, MESSAGES_INFO } from '../../../redux/actions/messagesActions';
import {
    AMBASSADOR_DIALOGS_INFO,
    CLEAR_DIALOGS_STORE,
    GROUP_DIALOGS_INFO,
    PROSPECT_DIALOGS_INFO,
} from '../../../redux/actions/dialogsActions';
import { HIDE_NEW_MESSAGES, OPEN_ACTION_MODAL } from '../../../redux/actions/componentsActions';

const ChatsSidebar = ({ isMobile, goToMessages }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    const account = useSelector((state) => state.account);
    const currentChat = useSelector((state) => state.currentChat);

    const changeChatsTab = useCallback(
        (type) => {
            navigate(`${getCommonRoutePath()}/interaction/dialogs`);

            dispatch({
                type: CLEAR_MESSAGES_STORE,
            });
            dispatch({
                type: CLEAR_DIALOGS_STORE,
            });
            dispatch({
                type: CHANGE_CHATS_TAB,
                payload: {
                    chats_type: type,
                },
            });
            if (type === 4) {
                dispatch({
                    type: GROUP_DIALOGS_INFO,
                    payload: {
                        isFirstLoad: false,
                    },
                });

                if (currentChat.groupLastChat && currentChat.groupLastChat.id) {
                    dispatch({
                        type: CLEAR_MESSAGES_STORE,
                    });
                    dispatch({
                        type: CHAT_INFO,
                        payload: {
                            dialog_id: currentChat.groupLastChat.id,
                            firstLoad: false,
                            type: 4,
                        },
                    });
                    const onFinish = (success = true, serverError = true) => {
                        if (!success) {
                            dispatch({
                                type: RESET_ACTIVE_CHAT,
                                payload: {
                                    resetOnlyGroupLastChat: true,
                                },
                            });
                            if (!serverError) {
                                dispatch({
                                    type: OPEN_ACTION_MODAL,
                                    payload: {
                                        title: 'You have been removed from conversation.',
                                    },
                                });
                            }
                        }
                    };

                    dispatch({
                        type: MESSAGES_INFO,
                        payload: {
                            dialog_id: currentChat.groupLastChat.id,
                            type_chat: 4,
                            blockReloadChat: true,
                            resetMessagesCounter: true,
                        },
                        onFinish: onFinish,
                    });

                    dispatch({
                        type: HIDE_NEW_MESSAGES,
                    });
                }
            } else if (account.account_info) {
                dispatch({
                    type: account.account_info.key === 'prospect' ? PROSPECT_DIALOGS_INFO : AMBASSADOR_DIALOGS_INFO,
                    payload: {
                        isFirstLoad: false,
                    },
                });
                if (currentChat.individualLastChat && currentChat.individualLastChat.id) {
                    dispatch({
                        type: CLEAR_MESSAGES_STORE,
                    });
                    // we don't need to call this chat info api, we only need members from it and chat avatar maybe, we could send that from dialogs info api
                    // remove it everywhere after we will have it in dialogs api
                    dispatch({
                        type: CHAT_INFO,
                        payload: {
                            dialog_id: currentChat.individualLastChat.id,
                            firstLoad: false,
                            type: 1,
                        },
                    });
                    const onFinish = (success = true, serverError = true) => {
                        if (!success) {
                            dispatch({
                                type: RESET_ACTIVE_CHAT,
                                payload: {
                                    resetOnlyIndividualLastChat: true,
                                },
                            });
                            if (!serverError) {
                                dispatch({
                                    type: OPEN_ACTION_MODAL,
                                    payload: {
                                        title: 'You have been removed from conversation.',
                                    },
                                });
                            }
                        }
                    };
                    dispatch({
                        type: MESSAGES_INFO,
                        payload: {
                            dialog_id: currentChat.individualLastChat.id,
                            type_chat: 4,
                            blockReloadChat: true,
                            resetMessagesCounter: true,
                        },
                        onFinish: onFinish,
                    });

                    dispatch({
                        type: HIDE_NEW_MESSAGES,
                    });
                }
            }
        },
        [dispatch, navigate, account, currentChat]
    );

    const handleShowMoreButtonClick = useCallback(
        (lastOffset) => {
            dispatch({
                type: GROUP_DIALOGS_INFO,
                payload: {
                    offset: lastOffset + 100,
                    type_chat: 4,
                },
            });
        },
        [dispatch]
    );

    const handleGoBack = useCallback(() => {
        if (sessionStorageWrapper.getItem('goBack')) {
            sessionStorageWrapper.removeItem('goBack');
        }
    }, []);

    const pathBack = getCommonRoutePath(true);
    return (
        <div className="chats-block">
            {isMobile ? (
                <>
                    <div
                        className={
                            !account.account_info || !account.account_info.key
                                ? 'chats-header-block mobile-unauthorized'
                                : 'chats-header-block mobile-chat'
                        }
                    >
                        <NavLink
                            end
                            to={pathBack}
                            className="btn chat-back-btn"
                            onClick={handleGoBack}
                            aria-label="Go back"
                            title="Back"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="7.657"
                                height="13.314"
                                viewBox="0 0 7.657 13.314"
                            >
                                <path
                                    d="M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"
                                    className="cls-1"
                                    transform="rotate(90 4.071 3.657)"
                                />
                            </svg>
                        </NavLink>
                        {account.account_info && account.account_info.key && (
                            <div
                                className={
                                    'chats-title-text' +
                                    (currentChat.chatsType === 1 || !currentChat.chatsType ? ' active' : '')
                                }
                                onClick={(e) => (currentChat.chatsType === 4 ? changeChatsTab(1) : null)}
                            >
                                Individual chats
                            </div>
                        )}
                        <div
                            className={'chats-title-text' + (currentChat.chatsType === 4 ? ' active' : '')}
                            onClick={(e) =>
                                currentChat.chatsType === 1 || !currentChat.chatsType ? changeChatsTab(4) : null
                            }
                        >
                            Group chats
                        </div>
                    </div>
                </>
            ) : (
                account.account_info &&
                account.account_info.key && (
                    <div className="chats-header-block">
                        <div
                            className={
                                'chats-title-text' +
                                (currentChat.chatsType === 1 || !currentChat.chatsType ? ' active' : '')
                            }
                            onClick={(e) => (currentChat.chatsType === 4 ? changeChatsTab(1) : null)}
                        >
                            Individual chats
                        </div>
                        <div
                            className={'chats-title-text' + (currentChat.chatsType === 4 ? ' active' : '')}
                            onClick={(e) =>
                                currentChat.chatsType === 1 || !currentChat.chatsType ? changeChatsTab(4) : null
                            }
                        >
                            Group chats
                        </div>
                    </div>
                )
            )}
            {currentChat.isFirstLoading && params.dialog_id ? (
                <div className="chat-nav">
                    <Loader />
                </div>
            ) : (currentChat.chatsType === 1 || !currentChat.chatsType) && account.account_info ? (
                <IndividualChats
                    isMobile={isMobile}
                    goToMessages={goToMessages}
                    handleShowMoreButtonClick={handleShowMoreButtonClick}
                />
            ) : (
                <GroupChats
                    isMobile={isMobile}
                    goToMessages={goToMessages}
                    handleShowMoreButtonClick={handleShowMoreButtonClick}
                />
            )}
        </div>
    );
};

export default ChatsSidebar;
